module.exports = __webpack_public_path__ + "media/public/img/google-round-color-01-1c8f9e1381e34336f60ccf5b48a61c9f.svg";